const modal = () => {
    document.querySelectorAll('.js-modal-open').forEach(btn => {
        btn.addEventListener('click', () => {
            const id = btn.dataset.modal;
            document.getElementById(id).classList.add('is-active');
        });
    });

    document.querySelectorAll('.js-modal-close').forEach(btn => {
        btn.addEventListener('click', () => {
            btn.closest('.modal').classList.remove('is-active');
        });
    });
}

const smoothScrollWithHeader = () => {
    const header = document.querySelector('.l-header');
    const nav = document.querySelector('.pg-nav');
    const navHeight = nav ? nav.offsetHeight:0;
    let headerHeight = header ? header.offsetHeight : 0;
    headerHeight = headerHeight+navHeight;

    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.js-scroll');
        if (!trigger) return;

        const targetId =
            trigger.dataset.target ||
            trigger.getAttribute('href');

        if (!targetId || !targetId.startsWith('#')) return;

        const target = document.querySelector(targetId);
        if (!target) return;

        e.preventDefault();

        const targetPosition =
            target.getBoundingClientRect().top +
            window.pageYOffset -
            headerHeight;

        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });


        // すべてのリンクから data-active を削除
        document.querySelectorAll(".js-menu-highlight a").forEach((el) => {
            el.removeAttribute("data-active");
        });
        // 現在のセクションに対応するリンクに data-active を付与
        trigger.setAttribute("data-active", "");

    });
};
const info = () => {
    modal();
    smoothScrollWithHeader();
}
export default info
